// スマートフォンでは上下の一覧ナビを個別に開閉する。
(function () {
  var mobile = window.matchMedia('(max-width: 767px)');
  var panelIndex = 0;
  var sortPlacements = [];
  var returnPlacements = [];

  // SPでは戻るリンクもカテゴリーと一緒に開閉し、PCでは元の位置に戻す。
  function placeReturns() {
    returnPlacements.forEach(function (placement) {
      if (mobile.matches) {
        placement.panel.appendChild(placement.links);
      } else {
        placement.marker.after(placement.links);
      }
    });
  }

  function placeSort() {
    sortPlacements.forEach(function (placement) {
      if (mobile.matches) {
        placement.nav.appendChild(placement.sort);
        placement.nav.classList.add('collection-link-nav--with-sort');
      } else {
        placement.marker.after(placement.sort);
        placement.nav.classList.remove('collection-link-nav--with-sort');
      }
    });
  }

  function initNavs() {
    document.querySelectorAll('.collection-link-nav > .collection-link-nav__returns').forEach(function (links) {
      if (links.hasAttribute('data-return-ready')) return;
      var panel = links.parentElement.querySelector('.collection-link-nav__panel');
      if (!panel) return;
      var marker = document.createComment('戻るリンクのPC表示位置');
      links.before(marker);
      links.setAttribute('data-return-ready', '');
      returnPlacements.push({ links: links, panel: panel, marker: marker });
    });
    placeReturns();
    document.querySelectorAll('.collection-link-nav__accordion').forEach(function (accordion) {
      if (accordion.hasAttribute('data-accordion-ready')) return;
      var toggle = accordion.querySelector('.collection-link-nav__toggle');
      var panel = accordion.querySelector('.collection-link-nav__panel');
      if (!toggle || !panel) return;
      panel.id = 'collection-link-nav-panel-' + (++panelIndex);
      toggle.setAttribute('aria-controls', panel.id);
      toggle.setAttribute('aria-expanded', mobile.matches ? 'false' : 'true');
      accordion.setAttribute('data-accordion-ready', '');
      toggle.addEventListener('click', function () {
        if (!mobile.matches) return;
        var isOpen = accordion.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    });
    document.querySelectorAll('.collection-link-nav[data-nav-position="top"]').forEach(function (nav) {
      if (nav.hasAttribute('data-sort-ready')) return;
      var section = nav.closest('[id^="shopify-section-"]');
      var select = section && section.querySelector('#SortBy');
      if (select) {
        var sort = select.closest('.filters-toolbar__item-child');
        if (sort) {
          var marker = document.createComment('並び替えのPC表示位置');
          sort.before(marker);
          sort.classList.add('collection-link-nav__sort');
          sortPlacements.push({ nav: nav, sort: sort, marker: marker });
        }
      }
      var allSort = nav.querySelector('[data-all-products-sort]');
      if (allSort) {
        nav.classList.add('collection-link-nav--all-sort');
        allSort.addEventListener('change', function () {
          // 全商品一覧の並び替えはShopifyの全商品コレクションで表示する。
          var url = new URL(window.location.href);
          url.pathname = url.pathname.replace(/\/collections\/?$/, '/collections/all');
          url.searchParams.set('sort_by', allSort.value);
          url.searchParams.delete('page');
          window.location.assign(url.href);
        });
      }
      nav.setAttribute('data-sort-ready', '');
    });
    placeSort();
  }

  mobile.addEventListener('change', function () {
    placeReturns();
    document.querySelectorAll('.collection-link-nav__accordion[data-accordion-ready]').forEach(function (accordion) {
      accordion.classList.remove('is-open');
      accordion.querySelector('.collection-link-nav__toggle').setAttribute('aria-expanded', mobile.matches ? 'false' : 'true');
    });
    placeSort();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavs);
  } else {
    initNavs();
  }
  document.addEventListener('shopify:section:load', initNavs);
})();
